import { library } from "@fortawesome/fontawesome-svg-core";
import { faVenus, faMars, faGlasses, faArrowCircleRight } from "@fortawesome/pro-regular-svg-icons";

library.add(faVenus, faMars, faGlasses, faArrowCircleRight);
